import { localize } from "utils/localizer";

const i18n = {
    advanceBookingMins: {
        en: "Allow booking in advance only within",
        de: "Erlaube Vorausbuchung nur innerhalb",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    closes: {
        en: "Closes",
        de: "Schließt",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    commercialCourt: {
        en: "Commercial-only court",
        de: "Rein kommerzieller Platz",
    },
    commercialCourtWarning: {
        en: "Setting this option is irreversible. The court has to be deleted to reset it, causing all future bookings on it to be cancelled.",
        de: "Das setzen dieser Eigenschaft ist irreversibel. Zum Zurücksetzen muss der Platz gelöscht werden, wodurch alle zukünftigen Buchungen darauf storniert werden.",
    },
    courts: {
        en: "Courts",
        de: "Plätze",
    },
    createCourt: {
        en: "Create Court",
        de: "Platz anlegen",
    },
    description: {
        en: "Description",
        de: "Beschreibung",
    },
    edit: {
        en: "Edit",
        de: "Bearbeiten",
    },
    editCourt: {
        en: "Edit Court",
        de: "Platz bearbeiten",
    },
    freeForClubMembers: {
        en: "Bookings free for members",
        de: "Buchungen kostenfrei für Mitglieder",
    },
    minNumParticipants: {
        en: "Minimum number of participants per booking",
        de: "Mindestanzahl an Mitspielern für Buchung",
    },
    minNumParticipantsInfo: {
        en: "Here you determine the minimum number of players required to pay for this booking (the creator needs to guarantee for this number of payments). Even members need to pay every booking in this case. Example: in a soccer park, one has to guarantee for 10 participants",
        de: "Hier legst du die Mindestanzahl an Playern fest, die für die Buchung bezahlen müssen (für diese Anzahl muss der Ersteller einer Buchung garantieren). Auch Mitglieder müssen dann jede Buchung bezahlen. Beispiel: in einer Soccer-Halle muss man für 10 Mitspieler garantieren",
    },
    name: {
        en: "Name",
        de: "Name",
    },
    noIndoor: {
        en: "No (indoor)",
        de: "Nein (drinnen)",
    },
    number: {
        en: "Number",
        de: "Nummer",
    },
    opens: {
        en: "Opens",
        de: "Öffnet",
    },
    price: {
        en: (isAlwaysPaidBooking: boolean) => `Price (for ${isAlwaysPaidBooking ? "guests and members" : "guests"})`,
        de: (isAlwaysPaidBooking: boolean) => `Preis (für ${isAlwaysPaidBooking ? "Gäste und Mitglieder" : "Gäste"})`,
    },
    priceInfo: {
        en: "Here you set the price per player and hour. Via \"Bookings free for members\" you can determine whether the price is only paid by guests or also by members.",
        de: "Hier legst du den Preis pro Spieler und Stunde fest. Über \"Buchungen kostenfrei für Mitglieder\" legst du fest, ob den Preis nur Gäste oder auch Mitglieder zahlen.",
    },
    priceRange: {
        en: "Between 1,00 € and 15,00 €",
        de: "Zwischen 1,00 € and 15,00 €",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    sportForm: {
        en: "Sport form",
        de: "Sportart",
    },
    surfaceType: {
        en: "Surface type",
        de: "Untergrund",
    },
    tier: {
        en: "Price",
        de: "Preis",
    },
    unrestricted: {
        en: "unrestricted",
        de: "unbeschränkt",
    },
    weatherDependent: {
        en: "Weather-dependent",
        de: "Wetterabhängig",
    },
    yesOutdoor: {
        en: "Yes (outdoor)",
        de: "Ja (draußen)",
    },
    latitude: {
        en: "Latitude",
        de: "Breitengrad",
    },
    longitude: {
        en: "Longitude",
        de: "Längengrad",
    },
};

export default localize(i18n);
